import {
  CREATE_TICKET,
  GET_MY_TICKETS,
  GET_TICKET_DETAILS,
  ASSIGN_TICKET,
  AGENT_REPLY,
  CUSTOMER_REPLY,
  UPDATE_TICKET_STATUS,
  REOPEN_TICKET,
    GET_ALL_TICKETS, 
    UPDATE_TICKET_PROPERTIES,
  DELETE_TICKET,
  MARK_TICKET_AS_READ,
  RATE_TICKET,
} from "../actions/types";

// ✅ Pattern same as setuphrstaffbasicinformationReducer.js

const initialState = {
  ticketList: [],
  selectedTicket: null,
  ticketSaveStatus: null,
  ticketUpdateStatus: null,
  replyStatus: null,
  assignStatus: null,
   allTicketsList: [],   
  selectedTicket: null,
  updatePropertiesStatus: null,   
  deleteStatus: null,            
  markAsReadStatus: null,         
  rateTicketStatus: null,  
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MY_TICKETS:
      return {
        ...state,
        ticketList: action.payload.data,
      };

    case GET_TICKET_DETAILS:
      return {
        ...state,
        selectedTicket: action.payload.data,
      };

    case CREATE_TICKET:
      return {
        ...state,
        ticketSaveStatus: action.payload.success,
      };

    case UPDATE_TICKET_STATUS:
    case REOPEN_TICKET:
      return {
        ...state,
        ticketUpdateStatus: action.payload.success,
      };

    case AGENT_REPLY:
    case CUSTOMER_REPLY:
      return {
        ...state,
        replyStatus: action.payload.success,
      };

    case ASSIGN_TICKET:
      return {
        ...state,
        assignStatus: action.payload.success,
      };
         case GET_ALL_TICKETS:
      return {
        ...state,
        allTicketsList: action.payload.data,
      };
      case UPDATE_TICKET_PROPERTIES:
  return {
    ...state,
    updatePropertiesStatus: action.payload.success,
  };

case DELETE_TICKET:
  return {
    ...state,
    deleteStatus: action.payload.success,
  };

case MARK_TICKET_AS_READ:
  return {
    ...state,
    markAsReadStatus: action.payload.success,
  };

case RATE_TICKET:
  return {
    ...state,
    rateTicketStatus: action.payload.success,
  };
    default:
      return state;
  }
}